/**
 * Service Controllers can be a useful way to encapsulate global pieces of
 * logic that need to talk to the webserver. This is intended for things
 * like grabbing pvsystem manufacturers, generating documents, uploading files.
 * They are not designed to be reactive and should not be used to share any
 * state that can change, but can still work as caches. Don't use a service
 * to sync state between different components, use events or Vuex intead for
 * that purpose. For example, the PvSystem Service can be used to query and
 * cache inverter and pv module manufacturers because those are effectively
 * constant, but when calculating pvSystem output, the result of the
 * calculation call is not stored or cached by the service; instead the
 * service is called from within a vuex action, which then stores the result
 * in the appropriate piece of state within the vuex store.
 */
export class ServiceController {
    constructor(state, pageController) {
        for (const key in state) {
            if (state.hasOwnProperty(key)) {
                const element = state[key];
                this[key] = element;
            }
        }
        pageController.connectObject(this);
        this.ProgramId = pageController.ProgramId;
    }
}
